import React, { FC } from 'react';
import * as OrderSummary from '../../../../../../shared/orders/model';
import { checkPermission, useUserSafe } from '../../../../../utils';
import { isOrderItemFulfillable, OrderStatusInfo } from '../utils';
import { OrderInfoItemGroup } from './OrderInfoItemGroup';

interface OrderListItemsProps {
  readonly order: OrderSummary.Order;
  readonly status: OrderStatusInfo[];
  readonly openAddProductModal: () => void;
  readonly onUpdate: () => void;
}

export const OrderListItems: FC<OrderListItemsProps> = ({
  status,
  order,
  openAddProductModal,
  onUpdate,
}) => {
  const user = useUserSafe();

  if (status.includes(OrderStatusInfo.Cancelled)) {
    return (
      <OrderInfoItemGroup
        icon="cancel_schedule_send"
        order={order}
        orderItems={order.orderItems}
        title="common.cancelled"
      />
    );
  }

  if (status.includes(OrderStatusInfo.Unpaid)) {
    return (
      <OrderInfoItemGroup
        addButton={checkPermission(user, 'registration:cashier') ? openAddProductModal : undefined}
        icon="hourglass_empty"
        onUpdate={onUpdate}
        order={order}
        orderItems={order.orderItems}
        title="common.pending_payment"
      />
    );
  }

  return (
    <>
      <OrderInfoItemGroup
        icon="cancel_schedule_send"
        onUpdate={onUpdate}
        order={order}
        orderItems={order.orderItems.filter(({ cancelledOn }) => cancelledOn)}
        title="common.cancelled"
      />
      <OrderInfoItemGroup
        icon="send"
        iconColor="primary"
        onUpdate={onUpdate}
        order={order}
        orderItems={order.orderItems.filter((oi) => oi.dispatchedOn ?? !isOrderItemFulfillable(oi))}
        title="common.fulfilled"
      />
      <OrderInfoItemGroup
        icon="schedule"
        iconColor="warning"
        onUpdate={onUpdate}
        order={order}
        orderItems={order.orderItems.filter((oi) => isOrderItemFulfillable(oi))}
        title="common.unfulfilled"
      />
    </>
  );
};
